module.exports = __webpack_public_path__ + "img/214d0.1c257139.svg";